const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Buttons/TelemedicineBtn.tsx';
import React, { useMemo, useState } from 'react';
import { Button, Typography, useTheme } from '@mui/material';
import VideoChatIcon from '@mui/icons-material/VideoChat';
import { css } from '@emotion/css';
import { useIntl } from 'react-intl';
import { ConfirmationDialog } from '@cistec/common_web/components/ConfirmationDialog/ConfirmationDialog';
import textMap from 'App/components/Buttons/translations';
import { getConfiguration } from 'App/utils/clientSetupGetRessource';

interface Props {
    externalLink?: string;
}

function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => ({
            button: css`
                min-width: auto;
                white-space: nowrap;
            `,
            dialog: css`
                white-space: pre-wrap;
            `,
            link: css`
                color: white;
                text-decoration: none;
            `,
        }),
        [theme]
    );
}

export const TelemedicineBtn = (props: Props) => {
    const { externalLink } = props;
    if (!externalLink) return null;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { videoCallDisclaimerText } = getConfiguration();
    const classes = useCSSClasses();
    const { formatMessage } = useIntl();

    const modalClose = () => {
        setIsModalOpen(false);
    };

    const handleButtonClick = () => {
        if (!videoCallDisclaimerText) {
            window.open(externalLink, '_blank', 'noreferrer');
        } else {
            setIsModalOpen(true);
        }
    };

    return (
        <>
            <Button
                variant="contained"
                onClick={handleButtonClick}
                startIcon={<VideoChatIcon />}
                size={'small'}
                color={'primary'}
                classes={{ root: classes.button }}
            >
                {formatMessage(textMap.telemedicine)}
            </Button>

            {videoCallDisclaimerText && isModalOpen && (
                <ConfirmationDialog
                    onClose={modalClose}
                    title={textMap.joinMeeting}
                    confirmText={
                        <a href={externalLink} target={'_blank'} rel="noreferrer" className={classes.link}>
                            {formatMessage(textMap.join)}
                        </a>
                    }
                    text={<Typography className={classes.dialog}>{formatMessage(videoCallDisclaimerText)}</Typography>}
                />
            )}
        </>
    );
};
